<div class="orchestrator" msOrchestratorContainer="any" msOrchestratorBlock="orchestrator">
  <div class="header" [ngClass]="theme" msOrchestratorBlock="header">
    <div class="settings">
      <button *ngIf="showTheme" [ngSwitch]="theme" class="theme" (click)="changeTheme()">
        <i class="fas fa-sun" *ngSwitchCase="'white'"></i>
        <i class="fas fa-moon" *ngSwitchCase="'black'"></i>
        <i class="fas fa-cloud-sun" *ngSwitchCase="'yellow'"></i>
      </button>

      <button
        *ngIf="showOrientation"
        [ngSwitch]="orientation"
        class="orientation"
        (click)="changeOrientation()"
      >
        <span *ngSwitchCase="'book'">{{ 'speedtestreading.book' | translate }}</span>
        <span *ngSwitchCase="'album'">{{ 'speedtestreading.albom' | translate }}</span>
      </button>
    </div>

    <div *ngIf="showTimer" class="timer"><i class="fas fa-clock"></i>{{ timer }}</div>
  </div>
</div>
